export default __webpack_public_path__ + "static/media/create_dec.2936a074.PNG";